// extracted by mini-css-extract-plugin
module.exports = {"container":"Tecnology_container__2JZWw","content":"Tecnology_content__2OR81","item":"Tecnology_item__1g5iR","all_categories":"Tecnology_all_categories__24QRG"};